import React, { useCallback } from 'react';
import classnames from 'classnames';

import './Switch.scss';

export interface SwitchProps {
  value?: boolean;
  onChange?;
  className?: string;
}

const Switch = ({ value, onChange, className }: SwitchProps) => {
  const handleChange = useCallback(
    ({ target: { checked } }) => {
      if (onChange) {
        onChange(checked);
      }
    },
    [onChange],
  );

  return (
    <label className={classnames('switch', className)}>
      <input
        type="checkbox"
        className="switch__checkbox"
        checked={value}
        onChange={handleChange}
      />
      <div className="switch__inner" />
    </label>
  );
};

export default Switch;
